import {IFilterFunction} from "angular";
import {OptionType} from "../models/OrderResponse";

export const OptionTypePipeId = "tfOptionType";
export const OptionTypeShortPipeId = "tfOptionTypeShort";


export function optionTypePipe(): IFilterFunction {
    return (value: OptionType | null) => {
        if (value == null) {
            return null;
        }
        switch (value) {
            case OptionType.PUT:
                return "Put";
            case OptionType.CALL:
                return "Call";
            default:
                return value;
        }
    };
}

export function optionTypeShortPipe(): IFilterFunction {
    return (value: OptionType | null) => {
        if (value == null) {
            return null;
        }
        switch (value) {
            case OptionType.PUT:
                return "P";
            case OptionType.CALL:
                return "C";
            default:
                return value;
        }
    };
}
